export const MarginBoxSize = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="1" y="1" width="20" height="20" stroke="#838280" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="6" y="6" width="10" height="10" stroke="#838280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}